import jobStatus from "../../../shared/variables/job-status";

import {
  GOLFER_INFORMATION,
  GOLFER_INFORMATION_SUCCESS,
  GOLFER_INFORMATION_FAILED,
} from "../actions";

const initialState = {
  status: jobStatus.NOT_STARTED,
  user: undefined,
  userError: undefined,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GOLFER_INFORMATION:
      return {
        ...state,
        status: jobStatus.PROCESSING,
      };
    case GOLFER_INFORMATION_SUCCESS: {
      return {
        ...state,
        status: jobStatus.SUCCESS,
        user: payload.golfer_user,
      };
    }
    case GOLFER_INFORMATION_FAILED: {
      return {
        ...state,
        userError:
          "This link is no longer active. Please ensure you have clicked on the link in the most recent email delivered.",
        status: jobStatus.FAILED,
      };
    }
    default:
      return state;
  }
};
